<template>
  <div>
    <div class="form-label fw-bold mb-2">{{ content }}</div>

    <div class="table-wrapper border shadow-sm">
      <table class="table table-striped m-0">
        <thead class="table-light">
          <tr>
            <th scope="col">#</th>
            <th scope="col" v-for="column in columns" :key="column">
              {{ column }}
            </th>
            <th scope="col" v-if="rows.length > 1"></th>
          </tr>
        </thead>
        <tbody>
          <tr class="align-middle" v-for="(row, idx) in rows" :key="idx">
            <th scope="row">{{ idx + 1 }}</th>
            <td v-for="(key, keyIdx) in Object.keys(row)" :key="key" class="">
              <FormInput
                :id="key"
                subtype="text"
                :hideLabel="true"
                :margin="true"
                :formInputValue="
                  formInputValue.length
                    ? formInputValue[idx][keyIdx]
                    : row[keyIdx]
                "
                @updateFormValue="updateFormValue(idx, keyIdx, $event)"
              />
            </td>
            <td class="text-end" v-if="rows.length > 1">
              <button
                v-show="idx !== 0"
                type="button"
                class="btn btn-outline-danger btn-sm shadow-sm"
                title="Remove Row"
                @click="removeRow(idx)"
              >
                <i class="bi bi-trash3"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="text-end pt-3">
      <button
        type="button"
        class="btn btn-outline-secondary shadow-sm"
        title="Add Row"
        @click="addRow()"
      >
        Add Row <i class="bi bi-plus-circle ms-1"></i>
      </button>
    </div>
  </div>
</template>

<script>
import FormInput from "@/components/activity/FormInput.vue";

export default {
  name: "FormTable",
  components: {
    FormInput
  },
  data() {
    return {
      rows: []
    };
  },
  props: {
    id: {
      type: String,
      required: true
    },
    content: {
      type: String,
      default: "Form Text Input Content"
    },
    columns: {
      type: Array,
      default: () => {
        return [];
      }
    },
    formInputValue: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  emits: ["updateTableValue", "tableChanged"],
  computed: {},
  methods: {
    updateFormValue(rowIndex, keyIndex, value) {
      if (!this.rows[rowIndex]) {
        this.rows[rowIndex] = {};
      }

      this.rows[rowIndex][keyIndex] = value;

      this.$emit("updateTableValue", this.rows);
    },
    createEmptyRow() {
      const row = {};

      console.log("Creating empty row for table", this.columns);

      if (!this.columns || !this.columns.length) {
        return row;
      }

      this.columns.forEach((_, index) => {
        row[index] = "";
      });

      return row;
    },
    addRow() {
      this.rows.push(this.createEmptyRow());
      this.$emit("tableChanged");
    },
    removeRow(index) {
      if (confirm("Are you sure you want to remove this row?")) {
        this.rows.splice(index, 1);
        this.$emit("tableChanged");
      }
    }
  },
  mounted() {
    console.log("Mounted FormTable with initial value:", this.formInputValue);
    if (this.formInputValue.length === 0) {
      this.rows.push(this.createEmptyRow());
    } else {
      this.rows = this.formInputValue;
    }
  },
  watch: {
    id() {
      console.log("FormTable ID changed to:", this.id);
      if (this.formInputValue.length === 0) {
        this.rows = [];
        this.rows.push(this.createEmptyRow());
      } else {
        this.rows = this.formInputValue;
      }
    }
  }
  /* lifecycle hooks */
};
</script>

<style scoped>
.table-wrapper {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  overflow: hidden; /* REQUIRED */
  /* border: 1px solid var(--bs-border-color); */
}
</style>
